import gql from 'graphql-tag';

export const getLeadEventsForDay = gql`
  query getLeadEventsForDay($input: GetLeadEventsFilter){
    getLeadEventsForDay(getPlanningEventsInput: $input){
        id
        userName
        userLastName
        userRoleType
        text
        type
        dateFrom
        dateTo
        textColor
        backgroundColor
        leadId
        leadContactName
        isOutBusinessHours
        endDefeatTime
        statusLead
        company{
          id,
          name
        }
    }
  }
`;
